import React from "react";
import { FaCar, FaFile, FaHome, FaPlane, FaStar } from "react-icons/fa";

const NavLinks = ({ content, setContent }) => {
  const links = [
    { id: "overview", label: "Overview", icon: FaHome },
    { id: "dropoffprocedure", label: "Drop-off", icon: FaPlane },
    { id: "pickupprocedure", label: "Pick-up", icon: FaCar },
    { id: "reviews", label: "Reviews", icon: FaStar },
    { id: "termscondition", label: "Terms", icon: FaFile },
  ];

  return (
    <div className="w-full">
      {/* Mobile/Tablet Compact Grid */}
      <div className="lg:hidden grid grid-cols-5 gap-1.5 sm:mb-4 mb-2">
        {links.map((item) => (
          <button
            key={item.id}
            className={`flex flex-col items-center justify-center gap-1.5 py-3 px-1 rounded-xl transition-all duration-300 ${content === item.id
                ? "bg-primary text-white shadow-lg ring-1 ring-primary/30"
                : "bg-white text-slate-500 border border-slate-100"
              }`}
            onClick={() => setContent(item.id)}
          >
            <div className={`p-1.5 rounded-lg transition-colors ${content === item.id ? "bg-white text-primary" : "bg-slate-50 text-slate-400"}`}>
              <item.icon className="text-[14px]" />
            </div>
            <span className="text-[8px] sm:text-[10px] font-black uppercase tracking-tighter truncate w-full text-center">
              {item.label}
            </span>
          </button>
        ))}
      </div>

      {/* Desktop Vertical Sidebar Links */}
      <div className="hidden lg:flex flex-col gap-2.5">
        {links.map((item) => (
          <button
            key={item.id}
            className={`group relative flex items-center gap-4 px-6 py-4 rounded-2xl transition-all duration-500 text-sm font-bold text-left overflow-hidden ${content === item.id
                ? "bg-primary text-white shadow-xl shadow-primary/20 translate-x-1"
                : "bg-transparent text-slate-500 hover:bg-slate-100 hover:text-slate-800"
              }`}
            onClick={() => setContent(item.id)}
          >
            <div className={`flex-shrink-0 w-9 h-9 flex items-center justify-center rounded-xl transition-all duration-300 ${content === item.id ? "bg-white/10 text-white" : "bg-slate-100 text-slate-400 group-hover:bg-white group-hover:text-primary"
              }`}>
              <item.icon size={18} />
            </div>
            <span className="flex-1 tracking-tight font-[900] uppercase text-[11px] lg:text-xs">{item.label}</span>
            {content === item.id && (
              <div className="w-2 h-2 rounded-full bg-secondary animate-pulse" />
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default NavLinks;
